import classNames from 'classnames';
import dompurify from 'dompurify';
import { isFunction } from 'lodash';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import { Tooltip } from 'primereact/tooltip';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class WrappedTooltip extends Component {
	renderContent() {
		const { tooltip, children } = this.props;

		if (isString(tooltip)) {
			// string content
			return (
				<div
					dangerouslySetInnerHTML={{
						__html: dompurify.sanitize(tooltip),
					}}
				/>
			);
		} else if (isFunction(tooltip)) {
			// functional component
			return tooltip();
		} else if (children) {
			// custom content by using JSX elements
			return isString(children) ? (
				<div
					dangerouslySetInnerHTML={{
						__html: dompurify.sanitize(children),
					}}
				/>
			) : (
				children
			);
		}

		return null;
	}

	render() {
		const { className, target, ...rest } = this.props;
		const content = this.renderContent();

		if (content) {
			return (
				<Tooltip
					className={classNames('common-ui-overlay-tooltip', {
						[className]: isString(className),
					})}
					target={isString(target) || isNumber(target) ? `.${target}` : null}
					data-qa="ui-tooltip"
					dataqa="ui-tooltip"
					{...rest}
				>
					{content}
				</Tooltip>
			);
		}

		return null;
	}
}

/**
 * Please refer to the official documentation for the rest props.
 * https://www.primefaces.org/primereact/tooltip/
 */
WrappedTooltip.propTypes = {
	tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};
